<script>
import { PermissionScope } from '@/shared/constants/permissions/PermissionScope'
import { mapGetters } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import { PermissionModifier } from '@/shared/constants/permissions/PermissionModifier'

export default {
  name: 'TheCreateBookingBtn',
  mixins: [baseMixin],
  props: {
    mini: { type: Boolean },
    extraMini: { type: Boolean },
    block: { type: Boolean },
  },
  computed: {
    ...mapGetters({
      hasPermissionRegardlessOfLevel: 'auth/hasPermissionRegardlessOfLevel',
    }),
    showCreateBookingButton() {
      return (
        this.hasPermissionRegardlessOfLevel(
          PermissionScope.BOOKING,
          PermissionModifier.CREATE
        ) ||
        this.hasPermissionRegardlessOfLevel(
          PermissionScope.PENDING_BOOKING,
          PermissionModifier.CREATE
        )
      )
    },
  },
}
</script>

<template>
  <section
    v-if="showCreateBookingButton"
    :class="[
      !mini ? 'px-4' : '',
      isMobileViewPort ? 'mb-2' : 'mb-6',
      'mt-1 text-center',
    ]"
  >
    <v-tooltip :disabled="!mini" right>
      <template v-slot:activator="{ on }">
        <BaseButton
          :fab="mini"
          :height="!mini ? 36 : 32"
          :width="block ? '100%' : !mini ? 204 : 32"
          color="blue"
          class="custom-elevation white--text rounded-lg"
          :class="[mini ? 'new-booking' : '']"
          :to="{ name: 'bookings-create' }"
          :prepend-icon="!mini ? 'mdi-plus' : ''"
          :icon="mini ? 'mdi-plus' : ''"
          v-on="on"
        >
          <span v-if="!mini"> {{ $t('booking.newBookingBtn') }} </span>
        </BaseButton>
      </template>
      <span>{{ $t('booking.newBookingBtnTooltip') }}</span>
    </v-tooltip>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
.new-booking {
  height: 32px !important;
}
.blue.darken-1 {
  background-color: $color-blue-400 !important;
  border: 1px solid $color-blue-400 !important;
}
</style>
